import React from 'react';
import styled from "styled-components";
import loadmore from "../assets/loadmore.png";
import { useScroll } from "./useScroll";


function Portfolio() {
  const [element, controls] = useScroll();
  return (
  <Section id="portfolio" ref={element}>
    <div className="portfolio-more">
        <span>Amazon・Rakutenの出店に関してどんな悩みでも解決します！！</span>
        <img src={loadmore} alt="Load More" />
    </div>
  </Section>
  );
}

const Section = styled.section`
min-height: 20vh;
padding-bottom: 2rem;
background-color: var(--secondary-color);

.portfolio-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin: 4rem 0;
  span {
    font-size: 20px;
    color: #fff;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    margin-top: 4rem;
  }
}
@media screen and (min-width: 280px) and (max-width: 1080px) { 

 
  .portfolio-more {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin: 4rem 0;
    span {
      font-size: 12px;
      color: #fff;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
      margin-top: 8rem;
    }
  }
}
`;

export default Portfolio
